module.exports = __webpack_public_path__ + "img/ind.c69946eb.svg";